import { render, staticRenderFns } from "./DashboardBanking.vue?vue&type=template&id=1a4d6d10"
import script from "./DashboardBanking.vue?vue&type=script&lang=js"
export * from "./DashboardBanking.vue?vue&type=script&lang=js"
import style0 from "./DashboardBanking.vue?vue&type=style&index=0&id=1a4d6d10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports